import { CreditNotesTable } from 'modules/billing/components/CreditNotesTable';
import { InvoicesTable } from 'modules/billing/components/InvoicesTable';
import { SubscriptionsTable } from 'modules/billing/components/SubscriptionsTable';
import React, { FunctionComponent } from 'react';
import { Divider, Header, Segment } from 'semantic-ui-react';

type Props = {
  companyId: number;
};

// Below the Zoho ones, to compare them during the migration
export const BillingSection: FunctionComponent<Props> = ({ companyId }) => (
  <>
    {/* Clears the floated button of the credit notes above */}
    <div style={{ clear: 'both' }} />
    <Segment color="blue" raised padded style={{ marginTop: '50px' }}>
      {/* The theme draws the headers of a segment thin and small */}
      <Header
        as="h2"
        color="blue"
        style={{ fontWeight: 700, fontSize: '1.7rem' }}
      >
        Pennylane{' '}
        <span style={{ fontSize: '1rem', fontWeight: 400, color: 'grey' }}>
          (admin only)
        </span>
      </Header>
      <Divider horizontal>Abonnements</Divider>
      <SubscriptionsTable companyId={companyId} />
      <Divider horizontal style={{ marginTop: '50px' }}>
        Factures
      </Divider>
      <InvoicesTable companyId={companyId} />
      <Divider horizontal style={{ marginTop: '50px' }}>
        Avoirs
      </Divider>
      <CreditNotesTable companyId={companyId} />
    </Segment>
  </>
);
